import React from 'react';
import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { StepRenderer } from './StepRenderer';
import { LessonStep } from '../../types/v2';

interface StepPreviewModalProps {
  open: boolean;
  onClose: () => void;
  step: LessonStep | null;
}

export const StepPreviewModal: React.FC<StepPreviewModalProps> = ({ open, onClose, step }) => {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-6">
          <Dialog.Panel className="w-full max-w-3xl rounded-2xl bg-white shadow-xl">
            <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
              <Dialog.Title className="text-lg font-semibold text-gray-900">Student Preview</Dialog.Title>
              <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600">
                <XMarkIcon className="h-5 w-5" />
              </button>
            </div>
            <div className="p-6">
              {step ? (
                <StepRenderer
                  title={step.title}
                  stageTag={step.stage_tag}
                  stepKind={step.step_kind}
                  content={step.content}
                />
              ) : (
                <p className="text-sm text-gray-500">Select a step to preview.</p>
              )}
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
};
